import React, { useState, useEffect, useContext, Fragment } from "react";
import { AuthContext } from '../../context/Auth.context';
import { dateFormat } from "../functions/dateFormat";
import Spinner from "../helpers/Spinner";
import { categoryAccountingInfo } from "../services/salesServices";
import Toast from "../helpers/Toast";
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import { useLocation } from "react-router-dom";

const CategoryBreackdown = () => {

    const { state, CheckResponse } = useContext(AuthContext);
    const [loading, setLoading] = useState(false);
    const [list, setList] = useState([]);
    const location = useLocation();
    const { date_from, date_to, category_id } = location.state || {};
    const [category_accounting, setCategoryAccounting] = useState([]);
    const [info_is_load, setInfoIsLoad] = useState(false);

    const showToast = (t, d, tt) => {
        setList([...list, {
            id: Math.floor((Math.random() * 101) + 1),
            title: t,
            description: d,
            type: tt
        }]);
    }

    const numberPrice = (n) => {
        return parseFloat(n).toFixed(2);
        // return parseFloat(newN);
    }

    useEffect(() => {
        loadCategoriesAccounting();
    }, []);

    const loadCategoriesAccounting = () => {
        setLoading(true);
        categoryAccountingInfo(state.auth, date_from, date_to, category_id).then(data => {
            CheckResponse(data);
            if (data.code == 200) {
                setCategoryAccounting(data.category_accounting);
            } else {
                showToast('Oops!', 'Algo salio mal!', 'danger');
            }
            setInfoIsLoad(true);
            setLoading(false);
        })
    }

    const makeExcel = () => {
        if (date_from && date_to) {
            setLoading(true);

            const processedData = category_accounting.ticket_details;

            if (!processedData || processedData.length === 0) {
                console.error("No data to process");
                return;
            }

            const workbook = new ExcelJS.Workbook();
            const worksheet = workbook.addWorksheet('Desglose '+category_accounting.name);

            const header = ["Ticket", "Prodcuto", "Cantidad", "Total", "Fecha de venta"];
            worksheet.addRow(header);

            worksheet.getRow(1).eachCell((cell) => {
                cell.font = { bold: true, color: { argb: 'FFFFFF' } };
                cell.alignment = { vertical: 'middle', horizontal: 'center' };
                cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: '000000' } };
            });

            processedData.forEach((row) => {
                worksheet.addRow([row.id, row.name, row.qty, numberPrice(row.total), dateFormat(row.created_at)]);
            });

            worksheet.columns.forEach((column) => {
                let maxLength = 0;
                column.eachCell({ includeEmpty: true }, (cell) => {
                    const cellValue = cell.value ? cell.value.toString() : '';
                    maxLength = Math.max(maxLength, cellValue.length);
                });
                column.width = maxLength + 2;
            });

            workbook.xlsx.writeBuffer().then((buffer) => {
                const blob = new Blob([buffer], { type: 'application/octet-stream' });
                saveAs(blob, `Desglose de contabilidad ${date_from}-${date_to} ${category_accounting.name}.xlsx`);
            });

            setTimeout(() => {
                showToast('Hecho!', 'Reporte descargado', 'success');
                setLoading(false);
            }, 3000);
        } else {
            showToast('Oops!', 'Algo salio mal!', 'danger');
        }
    };

    return (
        <>
            <Toast
                toastList={list}
            />
            <h1>Desgloce de Categoria</h1>

            {loading && <div className="col-sm-4 mt-1">
                <Spinner size={3} margin={4}></Spinner>
            </div>}
            {!loading && <>
                {info_is_load && <>
                    <div className="row mt-5">
                        <div className="col-sm-6 mt-1">
                            <h2 className="mt-4 me-2 w-100">{category_accounting.name}</h2>
                        </div>
                        <div className="col-sm-2 mt-1">
                            <button className="btn btn-success mt-4 w-100" onClick={() => { makeExcel() }}>Excel</button>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-sm-12 mt-4">
                            <table className="table table-hover">
                                <thead>
                                    <tr>
                                        <th>Ticket</th>
                                        <th>Producto</th>
                                        <th>Cantidad</th>
                                        <th>Total</th>
                                        <th>Fecha de venta</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {category_accounting.ticket_details?.map(item =>
                                        <tr key={item.id}>
                                            <td>{item.id}</td>
                                            <td>{item.name}</td>
                                            <td>{item.qty}</td>
                                            <td>{numberPrice(item.total)}</td>
                                            <td>{dateFormat(item.created_at)}</td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </>}
            </>}
        </>
    );
}

export default CategoryBreackdown;